import {IOn2ServerConfig, ISlsOrd} from "../kova/slsordClient";
import {User} from "../context/userContext";

interface IReservationResponse {
    success: boolean;
}
export class ReservationClient {
    constructor(private readonly config: IOn2ServerConfig) {

    }

    async reserve(slsOrd: ISlsOrd, user: User) {
        const response = await fetch(this.config.serverUri + `home/${slsOrd.id}/reserve/${user.id}`, {method: "POST"});
        const responseJson = await response.json() as IReservationResponse;
        return responseJson.success;
    }
    async leaveWaitlist(slsOrd: ISlsOrd, user:User) {
        const response = await fetch(this.config.serverUri + `home/${slsOrd.id}/leaveWaitlist/${user.id}`, {method: "POST"});
        const responseJson = await response.json() as IReservationResponse;
        return responseJson.success;
    }
}